// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pipeline-status{height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content;display:inline-block;border:1px solid #ccc;border-radius:20px;padding:2px 6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
